import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { DetalleInternoService } from './detalle-interno.service';
import { Mensaje } from '../../shared/models/mensaje';

@Injectable()
export class DetalleSolicitudInternoResolver implements Resolve<Mensaje> {

  constructor(private detalleInternoService: DetalleInternoService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Mensaje> | Promise<Mensaje> | Mensaje {
    return this.detalleInternoService.consultarDetalleSolicitud(+route.params['id']);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/core/services/detalle-solicitud-interno-resolver.service.ts